import { ORIGIN } from '../../shared/constants';
import { simStore, useSim } from '../state/sim';

/** Toggles the local GPS simulator. When on, tap the map to move your player. */
export function SimToggle() {
  const sim = useSim();
  return (
    <button
      className="sim-toggle"
      data-active={sim.enabled}
      data-testid="sim-toggle"
      onClick={() => simStore.toggle(ORIGIN)}
      title="Local GPS simulator: tap the map to move"
    >
      <span className={`dot ${sim.enabled ? 'dot--signal' : ''}`} />
      {sim.enabled ? 'Sim · tap map' : 'Sim'}
    </button>
  );
}
